import React from "react";
import moment from "moment";
import DropDown from "../../../components/dropDown";

export const PaymentFilter = ({
  startDate,
  endDate,
  selected,
  setStartDate,
  setEndDate,
  setSelected,
  submitHandler,
}) => {
  return (
    <>
      <h2 className="mt-12 text-center text-xl font-normal underline md:text-2xl lg:text-3xl">
        Transaction Summary
      </h2>
      <div className="mt-20 grid grid-cols-2 gap-5 sm:grid-cols-4 items-center sm:ml-8">
        <div className="col-span-1 grid gap-y-0.5">
          <label>Start Date</label>
          <input
            type="date"
            className="text-sm rounded-md px-2 py-2"
            value={startDate}
            onChange={(e) =>
              setStartDate(moment(e.target.value).format("YYYY-MM-DD"))
            }
          />
        </div>
        <div className="col-span-1 grid gap-y-0.5">
          <label>End Date</label>
          <input
            type="date"
            className="text-sm rounded-md px-2 py-2"
            value={endDate}
            onChange={(e) =>
              setEndDate(moment(e.target.value).format("YYYY-MM-DD"))
            }
          />
        </div>
        <div className="col-span-1 grid gap-y-0.5">
          <label>Transaction Type </label>
          <DropDown
            options={["All", "SUCCESS", "CANCELLED"]}
            selected={selected}
            setState={setSelected}
          />
        </div>
        <div className="col-span-1">
          <button
            className="mt-[24px] h-[39px] w-full outline-0 text-lg bg-gray-700 text-gray-50 hover:bg-gray-800 rounded-md px-2 sm:w-36"
            onClick={submitHandler}
          >
            See Result
          </button>
        </div>
      </div>
    </>
  );
};

export const ListFilter = ({ options, selected, setSelected, onClick }) => {
  return (
    <div className="mt-32 flex justify-between sm:px-8">
      <div className="w-40 sm:w-72">
        <DropDown
          options={options}
          selected={selected}
          setState={setSelected}
        />
      </div>
      <button
        className="text-custom-dodger-blue-300 text-sm underline cursor-pointer"
        onClick={onClick}
      >
        See All
      </button>
    </div>
  );
};
